/* eslint-disable import/no-anonymous-default-export */
import trans from "./pt/trans.json";
export const APP = trans.APP;
